<template>
  <div>
    <van-image
      width="100%"
      :src="url"
    />
  </div>
</template>

<script>
export default {
  data ({ $route }) {
    return {
      url: window.decodeURIComponent($route.query.url)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
